/**
 * Escape a regex from regex specific characters
 * @param string the string to escape
 * @param flags the regexp flags, default to i
 */
export function escapeRegExp(string?: string, flags = 'i') {
    return string ? new RegExp(string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), flags) : undefined;
}
